import React, { useState, useEffect } from "react";
import { Grid, Autocomplete, TextField, Checkbox, FormGroup, FormControlLabel, Card, CardContent, Typography, Button, Snackbar, Alert, CircularProgress } from "@mui/material";
import { useApiContext } from "../../../Utils/ApiContext/ApiContext";
import { getDecryptedAccessToken, getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import Calendar from "react-calendar";
import Loader from "../../../Container/Loader/Loader";
import "react-calendar/dist/Calendar.css";
import "./CalendarStyles.css";
import { useParams } from "react-router-dom";

const BookAppointment = ({patientData}) => {
  const { services, loading,fetchData } = useApiContext();
  const [filteredServices, setFilteredServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [availableSlots, setAvailableSlots] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [slotsForSelectedDate, setSlotsForSelectedDate] = useState([]);
  console.log("availableSlots",availableSlots)
  const [selectedSlot, setSelectedSlot] = useState(null);
  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();
  const LoginUserDetails = getDecryptedData()
  const allFacilities = [...new Set(services?.filter((s) => s.status === "1").map((s) => s.facility_type))];
  const [bookingLoading, setBookingLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const params = useParams()
const pid =
LoginUserType === "Patient" ? LoginUserDetails?.pid : patientData?.pid;

  useEffect(() => {
    let endpoint = '/apis/default/api/masterServices';
    if (LoginUserType === 'Patient') {
      endpoint = '/apis/default/portal/masterServices';
    }
    fetchData(endpoint);
  }, []);

  useEffect(() => {
    setSelectedFacilities(allFacilities);
  }, [services]);

  useEffect(() => {
    const filtered = services?.filter((s) => s.status === "1" && selectedFacilities.includes(s.facility_type));
    setFilteredServices(filtered);
  }, [services, selectedFacilities]);

  const handleFacilityChange = (facility) => {
    setSelectedFacilities((prev) =>
      prev.includes(facility) ? prev.filter((f) => f !== facility) : [...prev, facility]
    );
  };

  useEffect(() => {
    if (!selectedService) {
      setAvailableSlots({});
      setSlotsForSelectedDate([]);
      return;
    }

    const fetchAvailableSlots = async () => {
      try {
        let endpoint = `/apis/default/api/clinicslots/${selectedService.service_no}`;
        if (LoginUserType === "Patient") {
          endpoint = `/apis/default/portal/clinicslots/${selectedService.service_no}`;
        }

        const response = await ApiServices.get(endpoint, {
          Authorization: `Bearer ${accessToken}`,
        });

        const slotsByDate = response.data.data.reduce((acc, slot) => {
          if (slot.available) {
            acc[slot.date] = acc[slot.date] ? [...acc[slot.date], slot] : [slot];
          }
          return acc;
        }, {});

        setAvailableSlots(slotsByDate);
      } catch (error) {
        console.error("Error fetching available slots:", error);
      }
    };

    fetchAvailableSlots();
  }, [selectedService, LoginUserType, accessToken]);

  const formatLocalDate = (date) => {
  return date.toLocaleDateString("en-CA"); // Formats to YYYY-MM-DD
};

const handleDateClick = (date) => {
  const dateString = formatLocalDate(date);
  setSelectedDate(dateString);
  setSlotsForSelectedDate(availableSlots[dateString] || []);
  setSelectedSlot(null); // Reset slot selection on new date selection
};
  // const handleDateClick = (date) => {
  //   const dateString = date.toISOString().split("T")[0];
  //   setSelectedDate(dateString);
  //   setSlotsForSelectedDate(availableSlots[dateString] || []);
  //   setSelectedSlot(null); // Reset slot selection on new date selection
  // };

  const handleSlotSelection = (slot) => {
    setSelectedSlot(slot);
  };

  const tileDisabled = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today || [0, 1, 2, 3].includes(date.getDay());
  };

  console.log("selectedSlot",selectedSlot)

  const handleConfirmBooking = async () => {
    setBookingLoading(true);
    const data = {
      pc_catid: "5",
      pc_title:  selectedSlot.availability_mode === "offline" ? "Office Visit" : "Virtual Meeting",
      pc_duration: "1800",
      pc_hometext: "Test",
      pc_apptstatus: "^",
      pc_eventDate: selectedDate,
      pc_endDate: selectedDate,
      pc_startTime: selectedSlot.start_time,
      pc_endTime: selectedSlot.end_time,
      pc_facility: "9",
      pc_aid: selectedSlot.provider_id,
      pc_billing_location: "10",
      client_type: "Registered",
      is_billed: 0,
      assigned_by: null,
      appointment_type: selectedService.service,
      service_id: selectedService.service_no,
      appointment_note: "",
      systemSlotDuration: 60,
      is_virtual: selectedSlot.availability_mode === "offline" ? false : true,

    };

    try {
      let endpoint = `/apis/default/api/patient/${pid}/appointment`;
      if (LoginUserType === "Patient") {
        endpoint = `/apis/default/portal/patient/${pid}/appointment`;
      }

      await ApiServices.post(endpoint, data, {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      });

      setSnackbar({ open: true, message: "Appointment booked successfully!", severity: "success" });

      // Clear selection
      setSelectedService(null);
      setSelectedDate(null);
      setSlotsForSelectedDate([]);
      setSelectedSlot(null);
    } catch (error) {
      setSnackbar({ open: true, message: "Error booking appointment. Try again!", severity: "error" });
      console.error("Error booking appointment:", error);
    } finally {
      setBookingLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391",m:3 }}>
      Book New Appointment
        </Typography>

      <FormGroup row>
        {allFacilities.map((facility) => (
          <FormControlLabel
            key={facility}
            control={<Checkbox checked={selectedFacilities.includes(facility)} onChange={() => handleFacilityChange(facility)} />}
            label={facility}
          />
        ))}
      </FormGroup>
      <Autocomplete
        options={filteredServices}
        getOptionLabel={(option) => `${option.service} ${option.service_subtype ? `- ${option.service_subtype}` : ""}`}
        renderInput={(params) => <TextField {...params} label="Select Service" variant="outlined" />}
        fullWidth
        onChange={(event, newValue) => {
          setSelectedService(newValue);
          setSelectedDate(null);
          setSlotsForSelectedDate([]);
          setSelectedSlot(null);
        }}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
      />
      <Grid container spacing={2} sx={{mt:2}}>
        {/* Left Side - Calendar */}
        <Grid item sm={6} xs={12} >
          <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CardContent>
              <Calendar
                tileDisabled={tileDisabled}
                onClickDay={handleDateClick}
                tileContent={({ date }) => {
              const dateString = formatLocalDate(date);
                  // const dateString = date.toISOString().split("T")[0];

                  if (tileDisabled({ date })) return null;

                  return (
                    <div
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        fontSize: "12px",
                        marginTop: "4px",
                        color: availableSlots[dateString] ? "black" : "red",
                      }}
                    >
                      {availableSlots[dateString] ? availableSlots[dateString].length : 0} Slots
                    </div>
                  );
                }}
              />
            </CardContent>
          </Card>
        </Grid>

        {/* Right Side - Available Slots */}
        <Grid item sm={6} xs={12}>
          <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
  <CardContent>
    <Typography variant="h6">
      Available Slots for {selectedDate || "Select a date"}
    </Typography>

    {/* Helper function to render slot buttons */}
    {["online", "offline", "both"].map((mode) => {
      const modeLabel = {
        online: "Online Consultation",
        offline: "In Hospital Consultation",
        both: "Available for Both"
      };

      const filteredSlots = slotsForSelectedDate.filter(
        (slot) => slot.availability_mode === mode
      );

      return (
        <div key={mode} style={{ marginBottom: "20px" }}>
          <Typography variant="subtitle1" sx={{ margin: "10px 0" }}>
            {modeLabel[mode]}
          </Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {filteredSlots.length > 0 ? (
              filteredSlots.map((slot) => (
                <Button
                  key={slot.id}
                  variant={
                    selectedSlot?.start_time === slot.start_time ? "contained" : "outlined"
                  }
                  onClick={() => handleSlotSelection(slot)}
                  sx={{
                    minWidth: "100px",
                    backgroundColor:
                      selectedSlot?.start_time === slot.start_time
                        ? "#028391"
                        : "transparent",
                    color:
                      selectedSlot?.start_time === slot.start_time
                        ? "#fff"
                        : "#028391",
                    borderColor: "#028391",
                    "&:hover": {
                      backgroundColor:
                        selectedSlot?.start_time === slot.start_time
                          ? "#026b75"
                          : "#e0f7f5",
                    },
                  }}
                >
                  {slot.start_time} - {slot.end_time}
                </Button>
              ))
            ) : (
              <Typography>No slots available</Typography>
            )}
          </div>
        </div>
      );
    })}

    {/* Selected appointment details */}
    <div style={{ marginTop: "20px" }}>
      <Typography variant="h6">Selected Appointment Details</Typography>
      <Typography>Service: {selectedService?.service || "Not selected"}</Typography>
      <Typography>Date: {selectedDate || "Not selected"}</Typography>
      <Typography>
        Time:{" "}
        {selectedSlot
          ? `${selectedSlot.start_time} - ${selectedSlot.end_time}`
          : "Not selected"}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        disabled={!selectedService || !selectedDate || !selectedSlot || bookingLoading}
        sx={{
          marginTop: "15px",
          backgroundColor: "#028391",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#026b75",
          },
        }}
        onClick={handleConfirmBooking}
      >
        {bookingLoading ? <CircularProgress size={24} /> : "Book Appointment"}
      </Button>
    </div>
  </CardContent>
</Card>

        </Grid>
      </Grid>
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default BookAppointment;
